export const PV = {
  nav: "nav-placeholder-vocabulary",
  page: "placeholder-vocabulary-page",
  title: "placeholder-vocabulary-title",
  searchPlaceholder: "placeholder-vocabulary-search-placeholder",
  searchMeaning: "placeholder-vocabulary-search-meaning",
  statusFilter: "placeholder-vocabulary-status-filter",
  clearFilters: "placeholder-vocabulary-clear-filters",
  table: "placeholder-vocabulary-table",
  count: "placeholder-vocabulary-count",
  emptyState: "placeholder-vocabulary-empty",
  row: "placeholder-vocabulary-row",
};
